import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'
import { ShopDetailsSource } from 'sources'

@createActions(alt)
export default class ShopDetailsActions {
  constructor() {
    this.generateActions(
      'setFetching',
      'setDetails',
      'setErrored'
    )
  }

  fetch() {
    this.setFetching(true)
    return ShopDetailsSource.fetch()
      .then(resp => {
        this.setDetails(resp)
      })
      .catch(error => {
        console.log(error)
        this.setErrored(true)
      })
  }
}



// WEBPACK FOOTER //
// ./app/actions/ShopDetailsActions.js